// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getAnalytics } from "firebase/analytics";

import { fetchAndActivate, getRemoteConfig, getValue } from "firebase/remote-config";

import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";

// -----------------------------------------------
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// -----------------------------------------------
// Initialize Firebase
export const app = process.env.REACT_APP_ENV === 'dev' ?
  console.log("Firebase disabled Dev mode") : initializeApp(firebaseConfig);

export const vapIdKey = process.env.REACT_APP_ENV === 'dev' ?
  console.log("Firebase disabled Dev mode") : process.env.REACT_APP_FIREBASE_MSG_KEY;

// -----------------------------------------------
// Initialize Analytics
export const analytics = process.env.REACT_APP_ENV === 'dev' ?
  console.log("Firebase disabled Dev mode") : getAnalytics(app);

// -----------------------------------------------
// Initialize Firebase Cloud Messaging lazily — only after confirming the
// browser supports it. getMessaging() throws synchronously on unsupported
// browsers (WebView, in-app browsers) if called unconditionally at import time.
export const isFirebaseMsgSupported = process.env.REACT_APP_ENV === 'dev'
  ? Promise.resolve(false)
  : isSupported();

// messaging is resolved asynchronously so it is never called on unsupported browsers
let _messaging = null;
export const getMessagingInstance = async () => {
  if (_messaging) return _messaging;
  const supported = await isFirebaseMsgSupported;
  if (!supported) return null;
  try {
    _messaging = getMessaging(app);
  } catch (e) {
    console.warn('Firebase Messaging init failed:', e);
    _messaging = null;
  }
  return _messaging;
};

// Fetch FCM token
export const fetchToken = async () => {
  const messagingInstance = await getMessagingInstance();
  if (!messagingInstance) {
    console.log("Firebase Messaging is not supported in this browser or environment.");
    return undefined;
  }
  try {
    const currentToken = await getToken(messagingInstance, { vapidKey: vapIdKey });
    if (currentToken) {
      return currentToken;
    }
    console.log('No registration token available. Request permission to generate one.');
    return undefined;
  } catch (err) {
    console.log('An error occurred while retrieving token. ', err);
    return undefined;
  }
};

// Listen for messages (promise-based, resolves once — legacy)
export const onMessageListener = async () => {
  const messagingInstance = await getMessagingInstance();
  if (!messagingInstance) {
    console.log("Firebase Messaging is not supported in this browser or environment.");
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    onMessage(messagingInstance, (payload) => {
      resolve(payload);
    });
  });
};

// Subscribe to foreground messages (callback-based, continuous)
export const onForegroundMessage = async (callback) => {
  const messagingInstance = await getMessagingInstance();
  if (!messagingInstance) {
    console.log("Firebase Messaging is not supported in this browser or environment.");
    return () => { };
  }
  return onMessage(messagingInstance, callback);
};

// -----------------------------------------------
// -----------------------------------------------

// Initialize Remote Config and get a reference to the service
export const remoteConfig = process.env.REACT_APP_ENV === 'dev' ?
  console.log("Disabled in dev mode") : getRemoteConfig(app)

if (remoteConfig) {
  remoteConfig.settings = {
    minimumFetchIntervalMillis: 3600000, // 60 min / 1 Hour
  }
}

// fetch and activate values
export const userIdHashKey = process.env.REACT_APP_ENV === 'dev' ?
  console.log("Disabled in dev mode") : fetchAndActivate(remoteConfig)
    .then(() => {
      // get remote config value
      const hashKey = getValue(remoteConfig, "hash_key").asString();
      // console.log('hashKey: ', JSON.stringify(hashKey))
      return hashKey;
    })
    .catch((err) => {
      console.log(err)
    });



